var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imgBox min-w-1400"},[_c('div',{staticClass:"imgBox2 min-w-1400"},[_c('div',{staticClass:"img2 max-w-1400"},[_c('img',{staticClass:"imgItem2",attrs:{"src":_vm.productImg2,"alt":_vm.altText}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }